import * as React from "react";
const SVGComponent = ({ color = "#F0AD00", ...props }) => (
  <svg
    width={props?.width || 31}
    height={props?.height || 21}
    viewBox="0 0 31 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5176 0.427734C5.00362 0.427734 0.517578 4.91371 0.517578 10.4277C0.517578 15.9418 5.00356 20.4277 10.5176 20.4277C16.0316 20.4277 20.5176 15.9418 20.5176 10.4277C20.5176 4.91371 16.0316 0.427734 10.5176 0.427734ZM10.5176 1.90908C15.2309 1.90908 19.0361 5.71431 19.0361 10.4276C19.0361 15.1409 15.2309 18.9461 10.5176 18.9461C5.80428 18.9461 1.99906 15.1409 1.99906 10.4276C1.99906 5.71431 5.80428 1.90908 10.5176 1.90908V1.90908ZM10.5176 4.13144C10.1084 4.13144 9.7769 4.46316 9.7769 4.87211V10.4277C9.7769 10.7015 9.92623 10.9361 10.1474 11.0642C11.5285 11.8618 12.9272 12.6701 14.314 13.4715C14.6685 13.6761 15.1281 13.5596 15.3324 13.2054C15.537 12.8512 15.4089 12.403 15.0547 12.1983L11.2583 9.99953V4.87209C11.2583 4.46286 10.9266 4.13141 10.5176 4.13141L10.5176 4.13144Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;
